// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__9IW9D","productName":"Table_productName__2BWs0"};